import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/Alissa_Seth_OSC--cutout.png")